<template>
  <b-sidebar v-model="showModal" bg-variant="white" right backdrop shadow>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset">
        Add User
      </b-card-text>
      <!-- <b-card-text class="mt-1 h6 color-inherit text-reset">
        Users will be added to your subscription and will have shared access to your usage limits.
      </b-card-text> -->
      <h6 class="text-muted ml-1 mr-1">Users will have access to your quotas.</h6>
    </div>
    <b-list-group class="mt-2 rounded-0">
      <b-list-group-item class="bg-transparent">
        <b-form-group label="First name">
          <b-form-input v-model.trim="firstName" size="sm" placeholder="First name"></b-form-input>
        </b-form-group>
        <b-form-group label="Last name">
          <b-form-input v-model.trim="lastName" size="sm" placeholder="Last name"></b-form-input>
        </b-form-group>
        <b-form-group label="Email">
          <!-- <b-form-input v-model.trim="email" size="sm" placeholder="User email"></b-form-input> -->
          <SearchUser v-model="email" :is-email.sync="user" />
        </b-form-group>
      </b-list-group-item>
    </b-list-group>
    <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto cursor-pointer" @click="hide">Close</strong>
        <b-button size="sm" variant="primary" @click="onClickCreate()">Create</b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BButton, BListGroup, BListGroupItem, BFormGroup, BFormInput, BCardText } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SearchUser from '@/components/SearchUser'

export default {
  components: {
    SearchUser,
    BSidebar,
    BListGroup,
    BCardText,
    BButton,
    BListGroupItem,
    BFormGroup,
    BFormInput
  },
  directives: {
    Ripple
  },
  data() {
    return {
      email: '',
      user: null,
      firstName: '',
      lastName: ''
    }
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.billingUserModal.showModal
      },
      set(value) {
        this.email = ''
        this.user = null
        this.firstName = ''
        this.lastName = ''
        this.$store.dispatch('billingUserModal/onChangeModal', { visible: value })
      }
    }
  },
  methods: {
    async onClickCreate() {
      await this.$store.dispatch('billingUserModal/create', { firstName: this.firstName, lastName: this.lastName, email: this.email })
      this.showModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group {
  text-align: start;
}
.list-group-item {
  border: none !important;
}

.btn-role {
  width: 100%;
}
</style>
